import { useState } from 'react';

export const useLabelCallback = () => {
  const [availabilityIndicatorLabel, setAvailabilityIndicatorLabel] = useState('');

  const labelCallBack = (label: string) => {
    setAvailabilityIndicatorLabel(label);
    return label;
  };

  return { availabilityIndicatorLabel, labelCallBack };
};
